import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { Producto } from '../../_models/producto';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { ProductoService } from '../../_services/producto.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import {SelectItem} from 'primeng/api';
import {ListaService} from '../../_services/lista.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-producto-listado',
  templateUrl: 'producto-listado.component.html'
})
export class ProductoListadoComponent implements OnInit {

  productos: Producto[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  minorden: number = 0;
  maxorden: number = 0;
  lisTiposProductos: SelectItem[] = [];
  mostrarDialogoNuevo = false;
  formulario: FormGroup = new FormGroup({});
  submitted = false;

  //

  constructor(private proServicio: ProductoService,
    private navServicio: NavService,
    private autServicio: AutenticacionService,
    private router: Router,
    private lisServicio: ListaService,
              private fb: FormBuilder,) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find(x => x.ruta === 'apl/producto');
    if (mn) {
      this.menu = mn;
    }

    this.columnas = [
      {field: 'tipoProductoBancario', header: this.navServicio.buscarMensaje('PRODUCTO.LBL_TIPOPRODUCTO'), sort: false},
      {field: 'codigo', header: this.navServicio.buscarMensaje('PRODUCTO.LBL_CODIGO'), sort: false},
      {field: 'nombre', header: this.navServicio.buscarMensaje('PRODUCTO.LBL_PRODUCTO'), sort: false},
      {field: 'fechaInicioVigencia', header: this.navServicio.buscarMensaje('PRODUCTO.LBL_FECHAINICIAL'), sort: false},
      {field: 'fechaFinVigencia', header: this.navServicio.buscarMensaje('PRODUCTO.LBL_FECHAFINAL'), sort: false},
      {field: 'nombreTipoCupo', header: this.navServicio.buscarMensaje('PRODUCTO.LBL_TIPOCUPO'), sort: false},
      {field: 'nombreClasificacion', header: this.navServicio.buscarMensaje('PRODUCTO.LBL_CLASIFICACION'), sort: false},
      {field: 'orden', header: this.navServicio.buscarMensaje('PRODUCTO.LBL_ORDEN'), sort: false},
      {field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje('LBL_HABILITADO'), sort: false},
      {field: 'det', header: this.navServicio.buscarMensaje('LBL_ACCIONES'), sort: false}
    ];
    this.busqueda = this.navServicio.getSearch('producto.component');
    this.cargarLista();
    this.chargeproductos();

  }

  chargeproductos() {
    this.proServicio.listado().subscribe(productos => {
      productos = productos.sort(function (a, b) {
        return a.orden - b.orden;
      });
      this.productos = productos;
      this.minorden = this.productos[0].orden;
      this.maxorden = this.productos[this.productos.length - 1].orden;
      this.carTabla = false;
      this.cargarFormulario();
      this.tabla.filterGlobal(this.busqueda, 'contains');
    });
  }


  cargarLista(){
    this.lisServicio.getMasterDetails( 'ListasTiposProductosBancarios' ).subscribe(tiposProductos => {
      this.lisTiposProductos = tiposProductos.map (s => ({ label: s.nombre, value: s.idLista }) );
    });
  }


  crear() {
    this.submitted = false;
    this.formulario.reset();
    this.mostrarDialogoNuevo = true;
    //this.router.navigate(['apl/producto/agregar']);
  }

  ver(producto: Producto) {
    this.router.navigate(['apl/producto/detalle/' + producto.idProducto]);
  }

  editar(producto: Producto) {
    this.router.navigate(['apl/producto/actualizar/' + producto.idProducto])
  }

  setBusqueda() {
    this.navServicio.setSearch('producto.component', this.busqueda);
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idTipoProductoBancario: [  null, [Validators.required]],
    });
  }

  get f() {
    return this.formulario.controls;
  }

  changeorder(type: number, producto: Producto) {
    var editproduct: Producto;
    var index = (this.productos.indexOf(producto) + (type));
    editproduct = this.productos[index];
    var orden1 = producto.orden;
    var orden2 = editproduct.orden;
    producto.orden = orden2;
    editproduct.orden = orden1;
    this.editproduct(editproduct);
    this.editproduct(producto);
    this.productos = this.productos.sort(function (a, b) {
      return a.orden - b.orden;
    });
    this.minorden = this.productos[0].orden
    this.maxorden = this.productos[this.productos.length - 1].orden;
  }

  editproduct(producto: Producto) {
    this.proServicio.actualizar(producto).subscribe(rta => {
      this.navServicio.setMesage(2);
    }, error => {
      this.navServicio.setMesage(3);
    });
  }


  async guardar(){
    this.submitted = true;
    if(!this.formulario.valid) return;
    const objeto = this.formulario.value;
    this.router.navigate(['apl/producto/agregar/' + objeto.idTipoProductoBancario]);
  }

  async regresar(){
    this.mostrarDialogoNuevo = false;
  }


}
